import {
  Document,
  Image,
  Page,
  PDFViewer,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import React from "react";
import { logoRect } from "../../../assets";
import PropagateLoader from "react-spinners/PropagateLoader";
import moment from "moment";

const PaymentRequestDownload = (props) => {
  const { data, history } = props;
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    if (data) {
      setShow(true);
      console.log("Data:", data);
      console.log("History:", history);
    }
  }, [data, history]);

  const format = (val) => {
    if (val == null) {
      return "0.00";
    } else {
      return parseFloat(val).toFixed(2);
    }
  };

  const getTotalPaidAmount = (history) => {
    if (!history || history.length === 0) return "0.00";

    const total = history
      .flatMap((item) => item.payment || [])
      .filter((p) => p.is_active === 1)
      .reduce((sum, p) => sum + parseFloat(p.amount || 0), 0);

    return total;
  };

  const calculatePOBalance = () => {
    const itemDetails = data?.purchase_order?.purchase_order_item_details || [];

    const totalPO = itemDetails.reduce(
      (acc, curr) => acc + (parseFloat(curr.total_price) || 0),
      0
    );

    const paidAmount = getTotalPaidAmount(history);

    const balance = totalPO - paidAmount;

    return balance;
  };

  const poBalance = calculatePOBalance();

  const poCurrencyName =
    data?.purchase_order?.purchase_order_item_details?.[0]?.budgetitem
      ?.budgetquantitydetails?.actual_currency?.name || "N/A";

  const styles = StyleSheet.create({
    page: {
      flexDirection: "column",
      backgroundColor: "white",
      color: "black",
      width: "100%",
    },
    viewer: {
      width: window.innerWidth,
      height: window.innerHeight,
    },
    image: {
      width: "130px",
      height: "30px",
    },
    section: {
      margin: 10,
      padding: 10,
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      borderBottom: "1px solid black",
      marginRight: "25px",
      marginLeft: "25px",
    },
    footer: {
      position: "absolute",
      fontSize: 12,
      bottom: 30,
      marginLeft: "25px",
      marginRight: "25px",
      color: "black",
      display: "flex",
      flexDirection: "row",
    },
    // footer: {
    //     position: "absolute",
    //     fontSize: 12,
    //     bottom: 30,
    //     marginLeft: "25px",
    //     marginRight: "25px",
    //     color: "black",
    //     display: "flex",
    //     flexDirection: "row"
    // },
    pageNo: {
      position: "absolute",
      bottom: 10,
      left: 0,
      right: 0,
      textAlign: "center",
      fontSize: "10",
    },
  });

  return (
    <PDFViewer style={styles.viewer}>
      <>
        {show === true ? (
          <Document>
            <Page size="A4" style={styles.page}>
              <View fixed>
                <View style={styles.section} fixed>
                  <Image style={styles.image} src={logoRect} />
                  <Text style={{ fontSize: "20px" }}>PAYMENT REQUEST</Text>
                </View>
              </View>

              <View>
                <View>
                  <View
                    style={{
                      flexDirection: "row",
                      flexWrap: "wrap",
                      marginLeft: "25px",
                      marginRight: "25px",
                      border: "1px solid black",
                      marginTop: "7px",
                      borderRadius: "5px",
                    }}
                  >
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        borderBottom: "1px solid black",
                      }}
                    >
                      <Text
                        style={{
                          width: "30%",
                          fontSize: "8px",
                          borderRight: "1px solid black",
                          padding: "3px",
                          backgroundColor: "#f2f2f2",
                        }}
                      >
                        Project Name
                      </Text>
                      <Text
                        style={{
                          width: "70%",
                          fontSize: "8px",
                          padding: "3px",
                        }}
                      >
                        {data?.purchase_order?.purchase_order_item_details[0]
                          ?.budgetitem.budget.project.name
                          ? data?.purchase_order?.purchase_order_item_details[0]
                              ?.budgetitem.budget.project.name
                          : "N/A"}
                      </Text>
                    </View>
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <Text
                        style={{
                          width: "30%",
                          fontSize: "8px",
                          borderRight: "1px solid black",
                          padding: "3px",
                          backgroundColor: "#f2f2f2",
                        }}
                      >
                        Budget Number
                      </Text>
                      <Text
                        style={{
                          width: "70%",
                          fontSize: "8px",
                          padding: "3px",
                        }}
                      >
                        {data.purchase_order?.purchase_order_item_details[0]
                          ?.budgetitem.budget.serial_number +
                          " - " +
                          data.purchase_order?.purchase_order_item_details[0]
                            .budgetitem.budget?.name}
                      </Text>
                    </View>
                  </View>
                </View>
                <View>
                  <View
                    style={{
                      flexDirection: "row",
                      flexWrap: "wrap",
                      marginLeft: "25px",
                      marginRight: "25px",
                      border: "1px solid black",
                      marginTop: "9px",
                      borderRadius: "5px",
                    }}
                  >
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <Text
                        style={{
                          width: "100%",
                          fontSize: "9px",
                          padding: "3px",
                          backgroundColor: "#a4a4ce",
                          borderBottom: "1px solid black",
                        }}
                      >
                        PO DETAILS
                      </Text>
                    </View>
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        borderBottom: "1px solid black",
                      }}
                    >
                      <Text
                        style={{
                          width: "30%",
                          fontSize: "8px",
                          borderRight: "1px solid black",
                          padding: "3px",
                          backgroundColor: "#f2f2f2",
                        }}
                      >
                        Vendor
                      </Text>
                      <Text
                        style={{
                          width: "70%",
                          fontSize: "8px",
                          padding: "3px",
                        }}
                      >
                        {data.purchase_order.vendor.name}
                      </Text>
                    </View>
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        borderBottom: "1px solid black",
                      }}
                    >
                      <Text
                        style={{
                          width: "30%",
                          fontSize: "8px",
                          borderRight: "1px solid black",
                          padding: "3px",
                          backgroundColor: "#f2f2f2",
                        }}
                      >
                        PO Number
                      </Text>
                      <Text
                        style={{
                          width: "70%",
                          fontSize: "8px",
                          padding: "3px",
                        }}
                      >
                        {data.purchase_order_serial_number
                          ? data.purchase_order_serial_number
                          : "N/A"}
                      </Text>
                    </View>
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <Text
                        style={{
                          width: "30%",
                          fontSize: "8px",
                          borderRight: "1px solid black",
                          padding: "3px",
                          backgroundColor: "#f2f2f2",
                        }}
                      >
                        PO Value ({poCurrencyName})
                      </Text>
                      <Text
                        style={{
                          width: "70%",
                          fontSize: "8px",
                          padding: "3px",
                        }}
                      >
                        {data.purchase_order.purchase_order_item_details
                          .reduce((acc, curr) => {
                            return acc + parseFloat(curr.total_price);
                          }, 0)
                          .toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                      </Text>
                    </View>
                  </View>
                </View>
                <View>
                  <View
                    style={{
                      flexDirection: "row",
                      flexWrap: "wrap",
                      marginLeft: "25px",
                      marginRight: "25px",
                      border: "1px solid black",
                      marginTop: "10px",
                      borderRadius: "5px",
                    }}
                  >
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <Text
                        style={{
                          width: "100%",
                          fontSize: "9px",
                          padding: "3px",
                          backgroundColor: "#a4a4ce",
                          borderBottom: "1px solid black",
                        }}
                      >
                        PAYMENT HISTORY TO DATE
                      </Text>
                    </View>
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        borderBottom: "1px solid black",
                      }}
                    >
                      <Text
                        style={{
                          width: "30%",
                          fontSize: "8px",
                          borderRight: "1px solid black",
                          padding: "3px",
                          backgroundColor: "#f2f2f2",
                        }}
                      >
                        Requested Not Yet Paid Amount ({poCurrencyName})
                      </Text>
                      <Text
                        style={{
                          width: "70%",
                          fontSize: "8px",
                          padding: "3px",
                        }}
                      >
                        {history && history.length > 0
                          ? history
                              .filter((item) => {
                                if (!item.payment || item.payment.length === 0)
                                  return true;

                                return !item.payment.some(
                                  (p) => p.is_active === 1
                                );
                              })
                              .reduce(
                                (acc, curr) =>
                                  acc + parseFloat(curr.total_amount || 0),
                                0
                              )
                              .toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                          : "0.00"}
                      </Text>
                    </View>
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        borderBottom: "1px solid black",
                      }}
                    >
                      <Text
                        style={{
                          width: "30%",
                          fontSize: "8px",
                          borderRight: "1px solid black",
                          padding: "3px",
                          backgroundColor: "#f2f2f2",
                        }}
                      >
                        Paid Amount ({poCurrencyName})
                      </Text>
                      <Text
                        style={{
                          width: "70%",
                          fontSize: "8px",
                          padding: "3px",
                        }}
                      >
                        {getTotalPaidAmount(history).toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Text>
                    </View>
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <Text
                        style={{
                          width: "30%",
                          fontSize: "8px",
                          borderRight: "1px solid black",
                          padding: "3px",
                          backgroundColor: "#f2f2f2",
                        }}
                      >
                        Invoiced Amount ({poCurrencyName})
                      </Text>
                      <Text
                        style={{
                          width: "70%",
                          fontSize: "8px",
                          padding: "3px",
                        }}
                      >
                        {/* {data.total_amount} */}

                        {history &&
                          history.length > 0 &&
                          (
                            history.reduce((acc, curr) => {
                              if (curr.paid_amount != null) {
                                return acc + parseFloat(curr.total_amount || 0);
                              }
                              return acc;
                            }, 0) +
                            history.reduce((acc, curr) => {
                              if (curr.paid_amount == null) {
                                return acc + parseFloat(curr.total_amount || 0);
                              }
                              return acc;
                            }, 0)
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                      </Text>
                    </View>
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        borderTop: "1px solid black",
                      }}
                    >
                      <Text
                        style={{
                          width: "30%",
                          fontSize: "8px",
                          borderRight: "1px solid black",
                          padding: "3px",
                          backgroundColor: "#f2f2f2",
                        }}
                      >
                        PO Balance To Be Paid ({poCurrencyName})
                      </Text>
                      <Text
                        style={{
                          width: "70%",
                          fontSize: "8px",
                          padding: "3px",
                        }}
                      >
                        {poBalance.toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Text>
                    </View>
                  </View>
                </View>
                <View>
                  <View
                    style={{
                      flexDirection: "row",
                      flexWrap: "wrap",
                      marginLeft: "25px",
                      marginRight: "25px",
                      border: "1px solid black",
                      marginTop: "10px",
                      borderRadius: "5px",
                    }}
                  >
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <Text
                        style={{
                          width: "100%",
                          fontSize: "8px",
                          padding: "3px",
                          backgroundColor: "#a4a4ce",
                          borderBottom: "1px solid black",
                        }}
                      >
                        CURRENT PAYMENT
                      </Text>
                    </View>
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        borderBottom: "1px solid black",
                      }}
                    >
                      <Text
                        style={{
                          width: "30%",
                          fontSize: "8px",
                          borderRight: "1px solid black",
                          padding: "3px",
                          backgroundColor: "#f2f2f2",
                        }}
                      >
                        Invoice Received Date
                      </Text>
                      <Text
                        style={{
                          width: "70%",
                          fontSize: "8px",
                          padding: "3px",
                        }}
                      >
                        {moment(data.received_on.split(" ")[0]).format(
                          "DD-MM-YYYY"
                        )}
                      </Text>
                    </View>
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        borderBottom: "1px solid black",
                      }}
                    >
                      <Text
                        style={{
                          width: "30%",
                          fontSize: "8px",
                          borderRight: "1px solid black",
                          padding: "3px",
                          backgroundColor: "#f2f2f2",
                        }}
                      >
                        Invoice Due Date
                      </Text>
                      <Text
                        style={{
                          width: "70%",
                          fontSize: "8px",
                          padding: "3px",
                        }}
                      >
                        {moment(data.due_on.split(" ")[0]).format("DD-MM-YYYY")}
                      </Text>
                    </View>
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        borderBottom: "1px solid black",
                      }}
                    >
                      <Text
                        style={{
                          width: "30%",
                          fontSize: "8px",
                          borderRight: "1px solid black",
                          padding: "3px",
                          backgroundColor: "#f2f2f2",
                        }}
                      >
                        Invoice #
                      </Text>
                      <Text
                        style={{
                          width: "70%",
                          fontSize: "8px",
                          padding: "3px",
                        }}
                      >
                        {data.invoice_name}
                      </Text>
                    </View>
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        borderBottom: "1px solid black",
                      }}
                    >
                      <Text
                        style={{
                          width: "30%",
                          fontSize: "8px",
                          borderRight: "1px solid black",
                          padding: "3px",
                          backgroundColor: "#f2f2f2",
                        }}
                      >
                        Invoice Type
                      </Text>
                      <Text
                        style={{
                          width: "70%",
                          fontSize: "8px",
                          padding: "3px",
                        }}
                      >
                        {data.payment_progress.name
                          ? data.payment_progress.name
                          : "N/A"}
                      </Text>
                    </View>
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <Text
                        style={{
                          width: "30%",
                          fontSize: "8px",
                          borderRight: "1px solid black",
                          padding: "3px",
                          backgroundColor: "#f2f2f2",
                        }}
                      >
                        Invoice Value ({poCurrencyName})
                      </Text>
                      <Text
                        style={{
                          width: "70%",
                          fontSize: "8px",
                          padding: "3px",
                        }}
                      >
                        {data.total_amount >= 0
                          ? parseFloat(data.total_amount).toLocaleString(
                              "en-US",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )
                          : "0.00"}
                      </Text>
                    </View>
                  </View>
                </View>
                <View>
                  <View
                    style={{
                      flexDirection: "row",
                      flexWrap: "wrap",
                      marginLeft: "25px",
                      marginRight: "25px",
                      border: "1px solid black",
                      marginTop: "10px",
                      borderRadius: "5px",
                    }}
                  >
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <Text
                        style={{
                          width: "30%",
                          fontSize: "8px",
                          padding: "3px",
                          backgroundColor: "#a4a4ce",
                          borderRight: "1px solid black",
                        }}
                      >
                        TO BE INVOICED BALANCE ({poCurrencyName})
                      </Text>
                      <Text
                        style={{
                          width: "70%",
                          fontSize: "8px",
                          padding: "3px",
                          backgroundColor: "#f2f2f2",
                        }}
                      >
                        {parseFloat(
                          data.purchase_order.purchase_order_item_details.reduce(
                            (acc, curr) => {
                              return acc + parseFloat(curr.total_price);
                            },
                            0
                          ) -
                            ((history && history.length >= 1
                              ? history.reduce((acc, curr) => {
                                  return (
                                    acc +
                                    (curr.paid_amount != null
                                      ? parseFloat(curr.total_amount)
                                      : 0)
                                  );
                                }, 0)
                              : 0) +
                              (history && history.length >= 1
                                ? history.reduce((acc, curr) => {
                                    return (
                                      acc +
                                      (curr.paid_amount == null
                                        ? parseFloat(curr.total_amount)
                                        : 0)
                                    );
                                  }, 0)
                                : 0) +
                              parseFloat(data.total_amount))
                        ).toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Text>
                    </View>
                  </View>
                </View>
                <View>
                  <View
                    style={{
                      flexDirection: "row",
                      flexWrap: "wrap",
                      marginLeft: "25px",
                      marginRight: "25px",
                      border: "1px solid black",
                      marginTop: "10px",
                      borderRadius: "5px",
                    }}
                  >
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        borderBottom: "1px solid black",
                      }}
                    >
                      <Text
                        style={{
                          width: "30%",
                          fontSize: "8px",
                          borderRight: "1px solid black",
                          padding: "3px",
                          backgroundColor: "#f2f2f2",
                        }}
                      >
                        Payment Currency
                      </Text>
                      <Text
                        style={{
                          width: "70%",
                          fontSize: "8px",
                          padding: "3px",
                        }}
                      >
                        {poCurrencyName}
                      </Text>
                    </View>
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        borderBottom: "1px solid black",
                      }}
                    >
                      <Text
                        style={{
                          width: "30%",
                          fontSize: "8px",
                          borderRight: "1px solid black",
                          padding: "3px",
                          backgroundColor: "#f2f2f2",
                        }}
                      >
                        Mode of Payment
                      </Text>
                      <Text
                        style={{
                          width: "70%",
                          fontSize: "8px",
                          padding: "3px",
                        }}
                      >
                        {data.mode_of_payment.name
                          ? data.mode_of_payment.name
                          : "N/A"}
                      </Text>
                    </View>
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        borderBottom: "1px solid black",
                      }}
                    >
                      <Text
                        style={{
                          width: "30%",
                          fontSize: "8px",
                          borderRight: "1px solid black",
                          padding: "3px",
                          backgroundColor: "#f2f2f2",
                        }}
                      >
                        Bank Details
                      </Text>
                      <Text
                        style={{
                          width: "70%",
                          fontSize: "8px",
                          padding: "3px",
                        }}
                      >
                        {data.bank_details ? data.bank_details : "N/A"}
                      </Text>
                    </View>
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <Text
                        style={{
                          width: "30%",
                          fontSize: "8px",
                          borderRight: "1px solid black",
                          padding: "3px",
                          backgroundColor: "#f2f2f2",
                        }}
                      >
                        Required Documents
                      </Text>
                      <Text
                        style={{
                          width: "70%",
                          fontSize: "8px",
                          padding: "3px",
                        }}
                      >
                        {data.required_document.map((ele, index) => {
                          if (data.required_document.length > 1) {
                            return `${
                              ele.requireddocument.name +
                              (index == data.required_document.length - 1
                                ? ""
                                : ", ")
                            }`;
                          }
                          if (data.required_document.length == 1) {
                            return `${ele.requireddocument.name}`;
                          }
                        })}
                      </Text>
                    </View>
                  </View>
                </View>
                <Text
                  style={{
                    marginTop: "5px",
                    fontSize: "8px",
                    marginLeft: "25px",
                    marginRight: "25px",
                  }}
                >
                  Checked By Furnish
                </Text>
                <View
                  style={{
                    flexDirection: "row",
                    flexWrap: "wrap",
                    border: "1px solid black",
                    marginTop: "10px",
                    borderRadius: "5px",
                    marginRight: "25px",
                    marginLeft: "25px",
                  }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      fontSize: "10px",
                      borderBottom: "1px solid black",
                    }}
                  >
                    <Text
                      style={{
                        width: "30%",
                        fontSize: "10px",
                        borderRight: "1px solid black",
                        padding: "5px",
                        textAlign: "center",
                      }}
                    >
                      Name
                    </Text>
                    <Text
                      style={{
                        width: "40%",
                        fontSize: "10px",
                        padding: "5px",
                        borderRight: "1px solid black",
                        textAlign: "center",
                      }}
                    >
                      Signature
                    </Text>
                    <Text
                      style={{
                        width: "30%",
                        fontSize: "10px",
                        padding: "5px",
                        textAlign: "center",
                      }}
                    >
                      Date
                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      fontSize: "10px",
                      textAlign: "center",
                    }}
                  >
                    <Text
                      style={{
                        width: "30%",
                        height: "50px",
                        fontSize: "10px",
                        borderRight: "1px solid black",
                        padding: "5px",
                      }}
                    ></Text>
                    <Text
                      style={{
                        width: "40%",
                        height: "50px",
                        fontSize: "10px",
                        padding: "5px",
                        borderRight: "1px solid black",
                      }}
                    ></Text>
                    <Text
                      style={{
                        width: "30%",
                        height: "50px",
                        fontSize: "10px",
                        padding: "5px",
                      }}
                    ></Text>
                  </View>
                </View>
                <Text
                  style={{
                    marginTop: "5px",
                    fontSize: "8px",
                    marginLeft: "25px",
                    marginRight: "25px",
                  }}
                >
                  Authorized By Furnish
                </Text>
                <View
                  style={{
                    flexDirection: "row",
                    flexWrap: "wrap",
                    border: "1px solid black",
                    marginTop: "10px",
                    borderRadius: "5px",
                    marginRight: "25px",
                    marginLeft: "25px",
                  }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      fontSize: "10px",
                      borderBottom: "1px solid black",
                    }}
                  >
                    <Text
                      style={{
                        width: "30%",
                        fontSize: "10px",
                        borderRight: "1px solid black",
                        padding: "5px",
                        textAlign: "center",
                      }}
                    >
                      Name
                    </Text>
                    <Text
                      style={{
                        width: "40%",
                        fontSize: "10px",
                        padding: "5px",
                        borderRight: "1px solid black",
                        textAlign: "center",
                      }}
                    >
                      Signature
                    </Text>
                    <Text
                      style={{
                        width: "30%",
                        fontSize: "10px",
                        padding: "5px",
                        textAlign: "center",
                      }}
                    >
                      Date
                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      fontSize: "10px",
                      textAlign: "center",
                    }}
                  >
                    <Text
                      style={{
                        width: "30%",
                        height: "50px",
                        fontSize: "10px",
                        borderRight: "1px solid black",
                        padding: "5px",
                      }}
                    ></Text>
                    <Text
                      style={{
                        width: "40%",
                        height: "50px",
                        fontSize: "10px",
                        padding: "5px",
                        borderRight: "1px solid black",
                      }}
                    ></Text>
                    <Text
                      style={{
                        width: "30%",
                        height: "50px",
                        fontSize: "10px",
                        padding: "5px",
                      }}
                    ></Text>
                  </View>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    flexWrap: "wrap",
                    border: "1px solid black",
                    marginTop: "10px",
                    borderRadius: "5px",
                    marginRight: "25px",
                    marginLeft: "25px",
                  }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      fontSize: "10px",
                      borderBottom: "1px solid black",
                    }}
                  >
                    <Text
                      style={{
                        width: "30%",
                        fontSize: "10px",
                        borderRight: "1px solid black",
                        padding: "5px",
                        textAlign: "center",
                      }}
                    >
                      Name
                    </Text>
                    <Text
                      style={{
                        width: "40%",
                        fontSize: "10px",
                        padding: "5px",
                        borderRight: "1px solid black",
                        textAlign: "center",
                      }}
                    >
                      Signature
                    </Text>
                    <Text
                      style={{
                        width: "30%",
                        fontSize: "10px",
                        padding: "5px",
                        textAlign: "center",
                      }}
                    >
                      Date
                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      fontSize: "10px",
                      textAlign: "center",
                    }}
                  >
                    <Text
                      style={{
                        width: "30%",
                        height: "50px",
                        fontSize: "10px",
                        borderRight: "1px solid black",
                        padding: "5px",
                      }}
                    ></Text>
                    <Text
                      style={{
                        width: "40%",
                        height: "50px",
                        fontSize: "10px",
                        padding: "5px",
                        borderRight: "1px solid black",
                      }}
                    ></Text>
                    <Text
                      style={{
                        width: "30%",
                        height: "50px",
                        fontSize: "10px",
                        padding: "5px",
                      }}
                    ></Text>
                  </View>
                </View>
                <View style={styles.footer} fixed>
                  <View>
                    {/* <Text style={{ fontSize: "8px" }}>PO BOX 282247, Dubai, UAE</Text> */}
                    {/* <Text style={{ fontSize: "8px" }}>tel +971 4 3307725</Text>
              <Text style={{ fontSize: "8px" }}>
                <Link
                  style={{ color: "black" }}
                  src="mailto:invitation@furnish-marketplace.com"
                >
                  invitation@furnish-marketplace.com
                </Link>
              </Text>
              <Text style={{ fontSize: "8px" }}>
                <Link
                  style={{ color: "black" }}
                  src="http://furnish-marketplace.com"
                >
                  furnish-marketplace.com
                </Link>
              </Text> */}
                  </View>
                  <View></View>
                </View>
              </View>
              <Text
                style={styles.pageNo}
                render={({ pageNumber, totalPages }) =>
                  `Page # ${pageNumber} / ${totalPages}`
                }
                fixed
              />
            </Page>
          </Document>
        ) : (
          <View style={{ paddingLeft: "15Px", marginLeft: "50%" }}>
            <PropagateLoader color="blue" />
          </View>
        )}
      </>
    </PDFViewer>
  );
};

export default PaymentRequestDownload;
